// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1V3HM";
var _4 = "promo-1WC6J";
var _5 = "promo__image-UosII";
var _6 = "promo__content-2OrWQ";
var _7 = "inner-svjzQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "promo", _5 as "promo__image", _6 as "promo__content", _7 as "inner" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "promo": _4, "promo__image": _5, "promo__content": _6, "inner": _7 }
